'use strict';
import React from 'react';

//region import D3
import * as request from 'd3-request';
import * as dateTimeFormatter from 'd3-time-format';
//endregion

import ModelRow from '../modelRow/ModelRow';

class ModelComparison extends React.Component {

  scrapingHubProjectId = 83564;
  scrapingHubKey = 'bc41bd2c7b2c4b9ca12d5284d960d811';
  fiveThirtyEightSpider = 'fiveThirtyEight';
  upshotSpider = 'upshot';
  usLocale = dateTimeFormatter.timeFormatLocale({
    'dateTime': '%x, %X',
    'date': '%-m/%-d/%Y',
    'time': '%-I:%M:%S %p',
    'periods': ['AM', 'PM'],
    'days': ['Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'],
    'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'],
    'shortMonths': ['Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec']
  });

  constructor(state) {
    super(state);

    this.state = {
      ... state,
      fiveThirtyEight: {
        clinton: undefined,
        trump: undefined,
        updated: undefined
      },
      nytimes: {
        clinton: undefined,
        trump: undefined,
        updated: undefined
      },
      predictWise: {
        clinton: undefined,
        trump: undefined,
        updated: undefined
      }
    }
  }

  componentDidMount() {

    //region FiveThirtyEight Request
    request.json(
      `https://app.scrapinghub.com/api/jobs/list.json?apikey=${this.scrapingHubKey}&project=${this.scrapingHubProjectId}&spider=${this.fiveThirtyEightSpider}&state=finished&count=1`
    )
      .get((error, response) => {
        if (error) {
          console.log(error);
          return;
        }

        //TODO get id of spider here, then use that to load the item.
        const jobId = response.jobs[0].id;

        request.json(
          `https://storage.scrapinghub.com/items/${jobId}/0?apikey=${this.scrapingHubKey}`
        )
          .get((error, response) => {
            if (error) {
              console.log(error);
              return;
            }
            this.setState({
              fiveThirtyEight: {
                clinton: response[0].clinton / 100,
                trump: response[0].trump / 100,
                updated: response[0].updated
              }
            })
          })
      });
    //endregion

    //region updated Upshot Spider Request
    request.json(
      `https://app.scrapinghub.com/api/jobs/list.json?apikey=${this.scrapingHubKey}&project=${this.scrapingHubProjectId}&spider=${this.upshotSpider}&state=finished&count=1`
    )
      .get((error, response) => {
        if (error) {
          console.log(error);
          return;
        }

        //get id of spider here, then use that to load the item.
        const jobId = response.jobs[0].id;

        // Request Item data
        request.json(
          `https://storage.scrapinghub.com/items/${jobId}/0?apikey=${this.scrapingHubKey}`
        )
          .get((error, response) => {
            if (error) {
              console.log(error);
              return;
            }

            // Create a time parser using US english as a locale
            let nyTimesParser = this.usLocale.parse('%A, %B %d at' +
              ' %I:%M %p');

            // Remove Timezone information, since d3-time-format does not
            // seem to handle it nicely
            let datestring = response[0].updated
                .replace(' ET', '')
              ;

            // Parse date and set year manually, since it isn't shown on the
            // page
            let date = nyTimesParser(datestring);
            date.setYear(2016);

            this.setState({
              nytimes: {
                clinton: parseInt(response[0].clinton) / 100,
                trump: parseInt(response[0].trump) / 100,
                updated: dateTimeFormatter.isoFormat(date)
              }
            })
          })
      });
    //endregion

    //region PredictWise
    request.json(
      'http://table-cache1.predictwise.com/history/table_1032.json'
    ).get((error, response) => {
      if (error) {
        console.log(error);
      }

      // Date Format looks like this: 07-26-2016 1:35AM
      // Corresponds to %m-%d-%Y %-I:%M%p
      let pwDateParser = dateTimeFormatter.timeParse('%m-%d-%Y');
      const isoFormatter = dateTimeFormatter.timeFormat('%Y-%m-%dT%H:%M:%S.%LZ');

      let update = pwDateParser(response.timestamp.split(' ')[0]);

      this.setState({
        predictWise: {
          clinton: parseInt(response.latest[0][1]) / 100,
          trump: parseInt(response.latest[1][1]) / 100,
          updated: dateTimeFormatter.isoFormat(update)
        }
      })
    });

    //endregion
  }

  render() {
    return (
      <div className='infographic'>
        <h4 className='ui header'>
          Die Siegeschancen (Prognosemodelle)
        </h4>

        <ModelRow clinton={this.state.fiveThirtyEight.clinton}
                  trump={this.state.fiveThirtyEight.trump} source={{
          name: 'FiveThirtyEight',
          url: 'http://projects.fivethirtyeight.com/2016-election-forecast/#plus'
        }} updated={this.state.fiveThirtyEight.updated}>
          <p>Diese Werte entsprechen der «Polls-Plus»-Simulation von Nate Silver.
          Dieses statistische Modell verwendet nicht nur die aktuellen
          Umfragewerte,
          sondern berücksichtigt auch <a target='_blank'
                                         href='http://fivethirtyeight.com/features/a-users-guide-to-fivethirtyeights-2016-general-election-forecast/'>
          historische und ökonomische Daten</a>.</p>
        </ModelRow>

        <ModelRow source={{
          name: 'The Upshot, NYT',
          url: 'http://www.nytimes.com/interactive/2016/upshot/presidential-polls-forecast.html'
        }} clinton={this.state.nytimes.clinton}
                  trump={this.state.nytimes.trump}
                  updated={this.state.nytimes.updated}>
          <p>Die «New York Times» verwendet für ihr Modell die aktuellen
          Umfragewerte sowie die historischen Wahlresultate der einzelnen Staaten.</p>
        </ModelRow>

        <ModelRow source={{
          name: 'PredictWise',
          url: 'http://predictwise.com/politics/2016-president-winner'
        }} clinton={this.state.predictWise.clinton}
                  trump={this.state.predictWise.trump}
                  updated={this.state.predictWise.updated}>
          <p>PredictWise verwendet die Daten von Prognosemärkten und
          Wettbörsen, um eine Vorhersage zu machen.</p>
        </ModelRow>
      </div>
    );
  }
}

export default ModelComparison



/** WEBPACK FOOTER **
 ** ./src/components/modelComparison/ModelComparison.js
 **/